import React, { FC, Suspense, useMemo } from "react"
import { RouteComponentProps } from "react-router"
import { Loader } from "dash-styled"
import { useAppState } from "../../../Hooks/useReduxState"
import { decodeParams } from "./AppDetailRoute"
import { encodeJobAPIListParams } from "../../../Models/API/JobModel"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { TaskLabelingWrapper } from "../../../Components/Views/Dashboard/Sections/AppDetail/Labeling/TaskLabelingWrapper"

interface Props {
    orgUsername: string
    appID: string
    jobID?: string
}

export const TaskLabelingRoute: FC<
    RouteComponentProps<
        Props,
        any,
        { onboarding?: boolean; isMessagesPath?: boolean; backPath?: string }
    >
> = ({ match, location: { state } }) => {
    const { appID, jobID, orgUsername } = match.params

    const selectedJobs = useMemo(() => {
        const { search } = window.location
        const s = search ? new URLSearchParams(search) : undefined
        if (!s) return
        const sel = s.get("selected")
        if (!sel) return
        return sel
            .slice(1, sel.length - 1)
            .split(",")
            .map(id => parseInt(id, 10))
    }, [])

    const location = useAppState(state => state.router.location)
    const decoded = useMemo(() => {
        const searchParams = new URLSearchParams(location.search)
        const decoded = decodeParams(orgUsername, searchParams)
        if (decoded.isError) return undefined
        const filterAndSort = decoded ? decoded.value.filterAndSort : undefined
        const params = decoded ? decoded.value.params : undefined
        const filter = params
            ? encodeJobAPIListParams(params).toString()
            : undefined
        return {
            filterAndSort,
            filter
        }
    }, [location.search, orgUsername])

    return (
        <AppAuthCheck {...match.params} scope="task:label">
            <Suspense fallback={<Loader />}>
                <TaskLabelingWrapper
                    orgUsername={orgUsername}
                    appID={appID}
                    jobID={jobID}
                    filter={decoded?.filter}
                    selectedJobs={selectedJobs}
                    filterAndSort={decoded?.filterAndSort}
                    routedFromMessages={state?.isMessagesPath}
                    isOnboarding={state?.onboarding}
                    backPath={state?.backPath}
                />
            </Suspense>
        </AppAuthCheck>
    )
}
